export const locations = {
                            "Emergency":"Emergency", 
                            "MetropolitanSydney":"Metropolitan Sydney",
                            "NSWCentralCoast": "NSW Central Coast",
                            "NorthernNSW":"Northern NSW",
                            "Regional": "Regional NSW",
                            "SouthernNSW" : "Southern NSW",
                            "SydneyTraffic" : "Sydney Traffic",
                            "WesternNSW" : "Western NSW"
                        };
export const PRE_TEMPLATE_TEXT ="For more information about traffic arrangements for the <enter event name>, press "